"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _Controllable = _interopRequireDefault(require("../decorators/Controllable"));

var _I18n = _interopRequireDefault(require("I18n"));

var _classNames = _interopRequireDefault(require("react-utils/classNames"));

var _reactAddonsPureRenderMixin = _interopRequireDefault(require("react-addons-pure-render-mixin"));

var _react = _interopRequireWildcard(require("react"));

var _reactDom = require("react-dom");

var _SyntheticEvent = _interopRequireDefault(require("../core/SyntheticEvent"));

var _Functions = require("../core/Functions");

var _UIButton = _interopRequireDefault(require("../button/UIButton"));

var _UISlideoutDrawer = _interopRequireDefault(require("../slideout/UISlideoutDrawer"));

var _lazyEval = _interopRequireDefault(require("../utils/lazyEval"));

var _createLazyPropType = _interopRequireDefault(require("../utils/propTypes/createLazyPropType"));

var _IMEAware = _interopRequireDefault(require("../decorators/IMEAware"));

var UIEditableControls = _react.default.createClass({
  displayName: "UIEditableControls",
  mixins: [_reactAddonsPureRenderMixin.default],
  propTypes: {
    _composing: _react.PropTypes.bool,
    cancelButtonUse: _react.PropTypes.string,
    cancelLabel: (0, _createLazyPropType.default)(_react.PropTypes.node).isRequired,
    children: _react.PropTypes.node,
    okButtonUse: _react.PropTypes.string,
    onCancel: _react.PropTypes.func,
    onFocus: _react.PropTypes.func,
    onOpenChange: _react.PropTypes.func,
    onSave: _react.PropTypes.func,
    open: _react.PropTypes.bool,
    responsive: _react.PropTypes.bool,
    saveDisabled: _react.PropTypes.bool,
    saveLabel: (0, _createLazyPropType.default)(_react.PropTypes.node).isRequired,
    saveOnEnter: _react.PropTypes.bool,
    use: _react.PropTypes.oneOf(['inset', 'flush'])
  },
  getDefaultProps: function getDefaultProps() {
    return {
      cancelButtonUse: 'tertiary-light',
      cancelLabel: function cancelLabel() {
        return _I18n.default.text('salesUI.UIEditableControls.cancel');
      },
      okButtonUse: 'tertiary',
      open: false,
      responsive: true,
      saveDisabled: false,
      saveLabel: function saveLabel() {
        return _I18n.default.text('salesUI.UIEditableControls.save');
      },
      saveOnEnter: true,
      use: 'inset'
    };
  },
  handleFocus: function handleFocus(evt) {
    var onFocus = this.props.onFocus;
    this.setIsOpen(true);
    (0, _Functions.callIfPossible)(onFocus, evt);
  },
  handleKeyUp: function handleKeyUp(_ref) {
    var key = _ref.key;
    var _this$props = this.props,
        saveDisabled = _this$props.saveDisabled,
        saveOnEnter = _this$props.saveOnEnter,
        _composing = _this$props._composing;
    if (_composing) return;

    switch (key) {
      case 'Enter':
        if (saveOnEnter && !saveDisabled) this.handleSave();
        return;

      case 'Escape':
        this.handleCancel();
        return;

      default:
        return;
    }
  },
  handleSave: function handleSave() {
    var onSave = this.props.onSave;
    (0, _reactDom.findDOMNode)(this).focus();
    this.setIsOpen(false);
    (0, _Functions.callIfPossible)(onSave);
  },
  handleCancel: function handleCancel() {
    var onCancel = this.props.onCancel;
    (0, _reactDom.findDOMNode)(this).focus();
    this.setIsOpen(false);
    (0, _Functions.callIfPossible)(onCancel);
  },
  setIsOpen: function setIsOpen(isOpen) {
    var onOpenChange = this.props.onOpenChange;
    (0, _Functions.callIfPossible)(onOpenChange, (0, _SyntheticEvent.default)(isOpen));
  },
  render: function render() {
    var _this$props2 = this.props,
        __composing = _this$props2._composing,
        cancelButtonUse = _this$props2.cancelButtonUse,
        cancelLabel = _this$props2.cancelLabel,
        children = _this$props2.children,
        className = _this$props2.className,
        okButtonUse = _this$props2.okButtonUse,
        onBlur = _this$props2.onBlur,
        __onCancel = _this$props2.onCancel,
        __onOpenChange = _this$props2.onOpenChange,
        __onSave = _this$props2.onSave,
        open = _this$props2.open,
        responsive = _this$props2.responsive,
        __saveDisabled = _this$props2.saveDisabled,
        __saveOnEnter = _this$props2.saveOnEnter,
        saveLabel = _this$props2.saveLabel,
        use = _this$props2.use,
        rest = (0, _objectWithoutProperties2.default)(_this$props2, ["_composing", "cancelButtonUse", "cancelLabel", "children", "className", "okButtonUse", "onBlur", "onCancel", "onOpenChange", "onSave", "open", "responsive", "saveDisabled", "saveOnEnter", "saveLabel", "use"]);
    var classes = (0, _classNames.default)('uiEditableControls', 'private-editable-control', className, {
      'private-editable-control--flush': use === 'flush'
    });
    return (
      /* eslint-disable jsx-a11y/no-static-element-interactions */
      _react.default.createElement("div", (0, _extends2.default)({
        className: classes,
        onBlur: onBlur,
        onFocus: this.handleFocus,
        onKeyUp: this.handleKeyUp
      }, rest), children, _react.default.createElement(_UISlideoutDrawer.default, {
        open: open
      }, _react.default.createElement("div", {
        className: "private-editable-control__controls",
        key: "controls"
      }, _react.default.createElement(_UIButton.default, {
        className: "private-editable-control__save",
        disabled: this.props.saveDisabled,
        onClick: this.handleSave,
        responsive: responsive,
        size: "extra-small",
        use: okButtonUse
      }, (0, _lazyEval.default)(saveLabel)), _react.default.createElement(_UIButton.default, {
        className: "private-editable-control__cancel",
        onClick: this.handleCancel,
        responsive: responsive,
        size: "extra-small",
        use: cancelButtonUse
      }, (0, _lazyEval.default)(cancelLabel)))))
      /* eslint-enable jsx-a11y/no-static-element-interactions */

    );
  }
});

var _default = (0, _IMEAware.default)((0, _Controllable.default)(UIEditableControls, ['open']));

exports.default = _default;
module.exports = exports.default;